import React from 'react'

const CategoriesContext = React.createContext(null)

const withCategories = Component => props => (
  <CategoriesContext.Consumer>
    {categories => <Component {...props} categories={categories} />}
  </CategoriesContext.Consumer>
)

export { CategoriesContext, withCategories }
